import { Navigate, Outlet } from 'react-router-dom'

/**
 * Componente que protege las rutas privadas de la aplicación.
 * @class
 * @param {Object} props - Propiedades del componente.
 * @param {Boolean} props.isAuthenticated - Valor que indica si el usuario está autenticado.
 */
const ProtectedRoute = ({ isAuthenticated }) => {
  if (!isAuthenticated) return <Navigate to="/404" />
  return <Outlet />
}

export default ProtectedRoute
